import jwt from 'jwt-encode'

export const encoding = (data) => {
    return jwt(data, process.env.REACT_APP_JWT_TOKEN)
}
